document.addEventListener('DOMContentLoaded', () => {
  const uploadButton = document.querySelector('[data-open-upload]');
  const uploadModal = document.getElementById('upload-modal');
  const uploadContent = uploadModal.querySelector('.upload-modal__content');
  const uploadOverlay = uploadModal.querySelector('.upload-modal__overlay');
  const uploadClose = uploadModal.querySelector('.upload-modal__close');
  const uploadCancel = uploadModal.querySelector('.upload-modal__cancel');
  const uploadSend = uploadModal.querySelector('.upload-modal__send');
  const uploadAddMorePhotos = uploadModal.querySelector(
    '.upload-modal__add-more-photos'
  );
  const uploadPreviewUploaded = uploadModal.querySelector(
    '.upload-modal__dropzone-preview-uploaded'
  );
  let canUpload = false;

  const humanFileSize = (size) => {
    const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return `${(size / Math.pow(1024, i)).toFixed(1)} ${
      ['B', 'KB', 'MB', 'GB'][i]
    }`;
  };

  // set the dropzone container id
  const id = '#upload-dropzone';
  const dropzoneElement = document.querySelector(id);

  // set the preview element template
  const previewNode = dropzoneElement.querySelector(
    `${id} .dropzone-preview__item`
  );
  previewNode.id = '';
  const previewTemplate = previewNode.parentNode.innerHTML;
  previewNode.parentNode.removeChild(previewNode);

  const uploadURL = 'https://luly-upload-fzfue6hmh4c6gcd4.canadaeast-01.azurewebsites.net/api/sharepoint_upload?code=ACCUoaqXsmh0VyuzwbdGHxZogGw-nEDXodZsLNv4exFAzFuQ6aQKQ=='

  // Initialize Dropzone
  const dropzone = new Dropzone(`${id} .upload-modal__dropzone`, {
    url: uploadURL,
    autoProcessQueue: false,
    previewsContainer: `${id} .upload-modal__previews`,
    maxFiles: 5,
    parallelUploads: 1,
    maxFilesize: 10,
    chunkSize: 1024,
    acceptedFiles:
      'image/jpeg,image/png,image/webp',
    accept: function (file, done) {
      if (file.type === 'image/svg+xml' || /\.svg$/i.test(file.name)) {
        done('SVG files are not allowed');
      } else {
        done();
      }
    },
    previewTemplate: previewTemplate,
    init: function () {
      let errorCount = 0;
      let successCount = 0;
      let sessionStarted = false;

      this.on('addedfile', function (file) {

        file.previewElement.querySelector(
          '.dropzone-preview__name'
        ).textContent = file.name;
        file.previewElement.querySelector(
          '.dropzone-preview__size'
        ).textContent = humanFileSize(file.size);
        const dropzoneItems = dropzoneElement.querySelectorAll(
          `${id} .dropzone-preview__item`
        );
        dropzoneItems.forEach((dropzoneItem) => {
          dropzoneItem.style.display = 'flex';
        });
      });

      this.on('maxfilesexceeded', function (file) {
        this.removeFile(file);
      });

      this.on('removedfile', function (file) {
        const dropzoneItems = dropzoneElement.querySelectorAll(
          `${id} .dropzone-preview__item`
        );

        dropzoneItems.forEach((dropzoneItem, index) => {
          if (index < dropzone.options.maxFiles) {
            const errorElement = dropzoneItem.querySelector(
              '.dropzone-preview__error'
            );
            errorElement.innerHTML = '';
          }
        });
      });

      this.on('uploadprogress', function (file, progress) {
        file.previewElement.classList.add('dropzone-preview__item--processing');
        const progressElement = file.previewElement.querySelector(
          '.dropzone-preview__progress'
        );

        const fileSize = humanFileSize(file.size);
        const uploadSize = humanFileSize((file.size * progress) / 100);
        const progressText = `${uploadSize} of ${fileSize}`;
        const progressTextElement = file.previewElement.querySelector(
          '.dropzone-preview__size'
        );
        progressTextElement.innerHTML = progressText;

        progressElement.style.width = progress + '%';
      });

      this.on('processing', function (file) {
        if (!sessionStarted) {
          errorCount = 0;
          successCount = 0;
          sessionStarted = true;
        }
      });

      this.on('complete', function (file) {
        if (canUpload && dropzone.getQueuedFiles().length > 0) {
          setTimeout(uploadNext, 500); // Process the next file after a short delay
        } else {
          canUpload = false; // Reset the flag when done
        }
      });

      this.on('queuecomplete', function () {
        // Show thank you only when all files succeeded (no errors) and at least one success
        if (errorCount === 0 && successCount > 0) {
          setTimeout(() => {
            this.removeAllFiles(true);
            uploadContent.classList.add('upload-modal__content--thank-you');
          }, 500);
        }
        sessionStarted = false;
      });

      this.on('error', function (file, message) {
        errorCount++;
        const errorElement = file.previewElement.querySelector(
          '.dropzone-preview__error'
        );
        if (errorElement) {
          errorElement.innerHTML = typeof message === 'string' ? message : 'Upload failed';
        }
      });

      this.on('success', function (file, response) {
        // Validate server response: treat server-declared errors as Dropzone errors
        let isOk = true;
        let parsed = null;
        try {
          parsed = typeof response === 'string' ? JSON.parse(response) : response;
        } catch (e) {
          parsed = null;
        }

        if (file.xhr && (file.xhr.status < 200 || file.xhr.status >= 300)) {
          isOk = false;
        }
        if (parsed && (parsed.error || parsed.success === false || parsed.ok === false || parsed.status === 'error')) {
          isOk = false;
        }

        if (!isOk) {
          const message = (parsed && (parsed.error || parsed.message)) || 'Upload failed';
          this.emit('error', file, message);
          return;
        }

        successCount++;

        // Move to uploaded list and finalize UI
        const progressElement = file.previewElement.querySelector(
          '.dropzone-preview__progress'
        );
        const progressTextElement = file.previewElement.querySelector(
          '.dropzone-preview__size'
        );
        const fileSize = humanFileSize(file.size);

        setTimeout(() => {
          file.previewElement.classList.add('upload-complete');
          if (progressElement) progressElement.remove();
          if (progressTextElement) progressTextElement.innerHTML = fileSize;
          uploadPreviewUploaded.prepend(file.previewElement);
        }, 200);
      });
    },
  });

  const openModal = () => {
    uploadModal.classList.add('upload-modal--visible');
  };

  const closeModal = () => {
    uploadModal.classList.remove('upload-modal--visible');
    uploadContent.classList.remove('upload-modal__content--thank-you');
    dropzone.removeAllFiles(true);
  };

  // Open modal
  uploadButton.addEventListener('click', openModal);

  // Close modal when clicking on the close button
  uploadClose.addEventListener('click', closeModal);

  // Close modal when clicking on the cancel button
  uploadCancel.addEventListener('click', closeModal);

  // Close modal when clicking on the overlay
  uploadOverlay.addEventListener('click', () => {
    uploadModal.classList.remove('upload-modal--visible');
  });

  // Close search drawer on Escape key press
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  // Reset modal when clicking on the "Add more photos" button
  uploadAddMorePhotos.addEventListener('click', () => {
    uploadContent.classList.remove('upload-modal__content--thank-you');
  });

  // Function to process the next file in the queue
  function uploadNext() {
    if (dropzone.getQueuedFiles().length > 0) {
      dropzone.processFile(dropzone.getQueuedFiles()[0]);
    }
  }

  // Handle the upload button click to process the queue
  uploadSend.addEventListener('click', function () {
    if (dropzone.getQueuedFiles().length > 0) {
      canUpload = true;
      uploadNext(); // Start processing the queue
    }
  });
});
